import classNames from 'classnames'

import type { PropsWithChildren, ReactElement } from 'react'

import './styles.scss'

interface Props {
  className?: string
  loading?: boolean
}

const ContentLayout = ({ children, className, loading = false }: PropsWithChildren<Props>): ReactElement => {
  return <div className={classNames('content-layout', className)}>{loading ? null : children}</div>
}

export default ContentLayout
